export const IDEMPOTENCY_HEADER = 'Idempotency-Key'

/**
 * One key per user attempt; reuse it on retry so a double click or a network retry
 * cannot create the same resource twice.
 */
export function newIdempotencyKey(): string {
  return crypto.randomUUID()
}

export function idempotencyHeaders(key: string) {
  return { [IDEMPOTENCY_HEADER]: key }
}
